import { create } from 'zustand';

export type OfflinePhase =
  | 'idle'
  | 'creating'
  | 'waiting-answer'
  | 'joining'
  | 'waiting-host'
  | 'connecting'
  | 'connected'
  | 'error';

export interface OfflineState {
  phase: OfflinePhase;
  role: 'host' | 'guest' | null;
  code: string | null;
  offerText: string | null;
  offerUrl: string | null;
  answerText: string | null;
  answerQrValue: string | null;
  localName: string;
  remoteName: string | null;
  error: string | null;
  connectedAt: number | null;
}

interface OfflineStore extends OfflineState {
  set: (patch: Partial<OfflineState>) => void;
  reset: () => void;
}

const initialState: OfflineState = {
  phase: 'idle',
  role: null,
  code: null,
  offerText: null,
  offerUrl: null,
  answerText: null,
  answerQrValue: null,
  localName: '',
  remoteName: null,
  error: null,
  connectedAt: null,
};

export const useOfflineStore = create<OfflineStore>()((set) => ({
  ...initialState,
  set: (patch) => set(patch),
  reset: () => set(initialState),
}));
